/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExternalProfileProfileIdDelete$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
}

export function externalProfileProfileIdDelete(http: HttpClient, rootUrl: string, params: ExternalProfileProfileIdDelete$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, externalProfileProfileIdDelete.PATH, 'delete');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as WearablesStrictHttpResponse<void>;
    })
  );
}

externalProfileProfileIdDelete.PATH = '/External/Profile/{profileId}';
